(function (upp) {
    'use strict';

    upp.controller('upp.points.PointsAssignCtrl', ['pointsService', 'appi', '$scope','$window', '$rootScope',
        function (pointsService, appi, $scope, $window, $rootScope) {
            appi.security.securable({scope:$scope})
                .then(function () {
                    appi.ui.changeActualOption({moduleKey2Display: 'point-assign', navbarKey: 'point-assign'}, "/pointscard");
                    appi.ui.showPageLoadingMsg();

                    $scope.sections = {
                        qr: 'qr',
                        gift: 'gift'
                    };
                    /**
                     * Show Main Div
                     *
                     */
                    $scope.showMainWindow = function () {
                        $window.location.href = "#!/pointscard"
                    };

                    pointsService.getUserPoints().then(function(user) {
                        $scope.section = $scope.sections.qr;
                        $scope.qrImage = user.qrImage;
                        $scope.current = user.current;

                        appi.ui.hidePageLoadingMsg();

                        console.log(user.current);
                        return user.current;
                    }).then(function(points) {

                        var checker =  pointsService.checkAssignPoints(points);
                        checker.onAssignPoints(function(current) {
                            $scope.received = current - $scope.current;
                            $scope.current = current;
                            $scope.section = $scope.sections.gift;
                        });

                        var watcher = $rootScope.$on('$routeChangeStart', function($event, next, current) {
                            if (checker && checker.cancel) {
                                checker.cancel();
                            }
                            watcher();
                        });
                    })

                });
        }
    ]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/points/controllers/points-assign-controller.js